export default "__VITE_ASSET__98a89562__"